import Components from "mpm-components";
import Utilities from "mpm-config/Utilities";
import React from "react"


export default (props) => {

    return (  <Components.Regions.BreadCrumb data={Utilities.getBreadCrumbData(["Profil", "parametre"])} size="tiny" />)
}